import { PrimaryButton } from '@/components';
import { Stack } from '@mui/material';
import { useUpdateUserCreditMutation } from '../hooks/use-update-user-credit-mutation';
import { useManageCreditFormContext } from '../hooks';
import { useUserIdFilter } from '../store';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';

export const ManageCreditActions = ({ onClose }: { onClose?: () => void }) => {
  const queryClient = useQueryClient();
  const { watch } = useManageCreditFormContext();
  const payload = watch();
  const creditId = useUserIdFilter();
  const updateUserCreditMutation = useUpdateUserCreditMutation({
    onSuccess: () => {
      toast.success('Credit awarded successfully');
      queryClient.invalidateQueries({ queryKey: ['credits', 'get-credits'] });
      if (onClose) onClose();
    },
  });

  const handleSubmit = () => {
    updateUserCreditMutation.mutate({
      id: creditId,
      data: payload,
    });
  };

  return (
    <Stack direction="row" pt={4} gap={2} justifyContent="flex-end">
      <PrimaryButton
        onClick={() => handleSubmit()}
        sx={{ padding: '10px 50px' }}
        disabled={updateUserCreditMutation.isPending}
      >
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: 8 }}
        >
          <path
            d="M13.5675 8.2775C14.2765 8.54182 14.9074 8.98065 15.4018 9.5534C15.8963 10.1261 16.2383 10.8143 16.3963 11.5543C16.5543 12.2943 16.5232 13.0621 16.3058 13.7869C16.0884 14.5116 15.6918 15.1699 15.1526 15.7007C14.6134 16.2316 13.949 16.6179 13.221 16.8239C12.4929 17.03 11.7247 17.0491 10.9873 16.8796C10.2498 16.7101 9.56709 16.3573 9.00212 15.854C8.43716 15.3507 8.00823 14.713 7.755 14M5.25 5H6V8M12.5325 10.91L13.0575 11.4425L10.9425 13.5575M10.5 6.5C10.5 8.98528 8.48528 11 6 11C3.51472 11 1.5 8.98528 1.5 6.5C1.5 4.01472 3.51472 2 6 2C8.48528 2 10.5 4.01472 10.5 6.5Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Award Credits
      </PrimaryButton>
    </Stack>
  );
};
